import { createFileRoute } from '@tanstack/react-router';
import { AdminSystemLogDetailPage } from '@/features/admin/admin-system-log-detail-page';

export const Route = createFileRoute('/admin/system-logs/$id')({
  component: AdminSystemLogDetailRoute,
});

function AdminSystemLogDetailRoute() {
  const { id } = Route.useParams();
  return <AdminSystemLogDetailPage logId={id} />;
}
